// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import shc_validator from "./shc.js";
import qr_validator from "./qr.js";
import jws_validator from "./jws.js";
import jws_header from "./jws.header.js";
import jws_payload from "./jws.payload.js";
import jws_compact from "./jws.compact.js";
import jws_flat from "./jws.flat.js";
import jws_signature from "./jws.signature.js";
import Context from "./context.js";
import signature_verifier from "./signature.js";
import fhir from "./fhir.js";
import { ErrorCode, LogLevel } from "./log.js";
import verify from "./verify.js";
import directory from "./directory.js";
import card from "./card.js";
const jwsEncode = jws_validator.encode;
jwsEncode.header = jws_header.encode;
jwsEncode.payload = jws_payload.encode;
jwsEncode.signature = jws_signature.encode;
jwsEncode.compact = jws_compact.encode;
jwsEncode.flat = jws_flat.encode;
const jwsDecode = {};
jwsDecode.header = jws_header.decode;
jwsDecode.payload = jws_payload.decode;
jwsDecode.signature = jws_signature.decode;
jwsDecode.compact = jws_compact.decode;
jwsDecode.flat = jws_flat.decode;
const jwsValidate = jws_validator.validate;
jwsValidate.header = jws_header.validate;
jwsValidate.payload = jws_payload.validate;
jwsValidate.signature = jws_signature.validate;
jwsValidate.compact = jws_compact.validate;
jwsValidate.flat = jws_flat.validate;
const validate = {
    qr: qr_validator.decode,
    shc: shc_validator.validate,
    jws: jwsValidate,
    fhir: fhir.validate,
};
const decode = {
    qr: qr_validator.decode,
    shc: shc_validator.decode,
    jws: jwsDecode
};
const encode = {
    shc: shc_validator.encode,
    jws: jwsEncode,
    fhir: fhir.encode
};
const signature = {
    verify: signature_verifier.verify,
    sign: signature_verifier.sign
};
const low = {
    encode,
    decode,
    validate,
    signature,
    card: card
};
export default { verify, Context, LogLevel, ErrorCode, directory, low };
export { verify, Context, LogLevel, ErrorCode, directory, low };
